import React, {Fragment} from 'react';
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import SelectorCalendar from "../../../form/SelectorGrid/SelectorCalendar";
import moment from 'moment';
import Select from "../../../form/Select";
import { sendRequest } from '../../../../utils/request';

class EventCalendar extends React.Component {

    onSelectionChange = (value) => {
        if (value.component_type === "ProgramCalendarItem") {
            this.props.setContent("Program", {id: value.program.id});
        } else {
            this.props.setContent(value.component_type || this.props.componentConfig.componentname, {id: value.id});
        }
    }

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {
            componentConfig,
            filter,
            loading: isLoading,
            pageSize: 0// important for SelectorCalendar
        };
        if (view) {
            props.view = view;
        }
        const colors = [
            {
                fn: (rowData) => {
                    return !parseInt(rowData.canceled || 0) && !parseInt(rowData.public || 0)
                },
                color: "not-public",
                label: "Nem publikus esemény"
            },
            {
                fn: (rowData) => {
                    return !parseInt(rowData.canceled || 0) && !!parseInt(rowData.public || 0);
                },
                color: "public",
                label: "Publikus esemény"
            },
            {
                fn: (rowData) => {
                    return !!parseInt(rowData.canceled || 0) || (rowData.component_type === "TimeConfigException");
                },
                color: "banned",
                label: "Időpont kivétel"
            },
            {
                fn: (rowData) => {
                    return !!parseInt(rowData.canceled || 0) || (rowData.component_type === "ProgramCalendarItem");
                },
                color: "default",
                label: "Lehetséges időpont"
            },
        ]
        return (
            <Fragment>
                <SelectorGrid
                    type={SelectorCalendar}
                    ref={(el) => this.list = el}
                    gridid={(this.props.gridid !== undefined ? this.props.gridid : "Event") + "Calendar"}
                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                    {...props}
                    filter={filter}
                    formatRows={(items) => {
                        return items.map((item) => {
                            item.editable = false;
                            item.locations = item.locations || (item.location ? [item.location] : []);
                            let name = (item.name || "");
                            if (item.program && item.program.name) {
                                name += name ? "\n" : "";
                                name += item.program.name;
                            }
                            if (item.locations && item.locations.length) {
                                name += name ? "\n" : " ";
                                name += (item.locations || []).map((location) => location.name).join(", ");
                            }
                            item.title = name;
                            item.start = moment(item.from, "YYYY-MM-DD HH:mm:ss").toDate();
                            item.end = moment(item.to, "YYYY-MM-DD HH:mm:ss").toDate();
                            return item;
                        })
                    }}
                    rowClassName={(rowData) => {
                        return {
                            ...colors.reduce((all, color) => ({...all, ["label label-" + color.color]: color.fn(rowData)}), {})
                        };
                    }}
                    view={["canceled", "public", "program.color"]}
                    columns={{
                        "id": {header: 'Kód', width: 1, sortable, filterable},
                        "program.name": {header: 'Program', width: 2, sortable, filterable},
                        "from": {header: 'Időtartam', width: 3, sortable, filterable},
                        "to": {header: 'Időtartam', width: 3, sortable, filterable},
                        "locations": {header: 'Hely', width: 2, renderer: (locations) => (locations || []).map((location) => location.name).join(", ")},
                    }}
                    onPage={(paging) => {
                        paging.filters = {
                            "from": {value: moment(paging.start).format("YYYY-MM-DD"), operator: ">"},
                            "to": {value: moment(paging.end).format("YYYY-MM-DD"), operator: "<"}
                        };
                        return paging;
                    }}
                    orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                    selection={selection}
                    onSelectionChange={(selection) => this.onSelectionChange({...selection.value.extendedProps, id: selection.value.id})}
                    onLoadCompleted={async (data, reqparams) => {
                        if (reqparams && reqparams.filter) {
                            let filter = JSON.parse(reqparams.filter);
                            let fromto = {};
                            let timeconfigExceptionFilter =  [];
                            filter.forEach((f) => {
                                if (f.field === "from" || f.field === "to") {
                                    fromto[f.field] = f.value;
                                }
                                if (f.field === "from" || f.field === "to" || f.field === "program") {
                                    timeconfigExceptionFilter.push(f);
                                } else if (f.field === "locations") {
                                    f.field = "location";
                                    timeconfigExceptionFilter.push(f);
                                }
                            });
                            let tceData = await sendRequest({
                                option: "componentlist",
                                component: "TimeConfigException",
                                filter: timeconfigExceptionFilter,
                                itemsperpage: 0,
                            });
                            tceData.items = tceData.items.map((item) => {
                                item.component_type = "TimeConfigException";
                                return item;
                            });
                            data.rows.push(...tceData.items);
                            data.fullcount = Number(data.fullcount) + tceData.items.length;

                            const locationEvents = await sendRequest({
                                option: "componentlist",
                                component: "LocationEvent",
                                filter: [
                                    {field: "program.public", value: 1},
                                    {field: "from", value: fromto.from + " 00:00:00", operator: ">="},
                                    {field: "to", value: fromto.to + " 23:59:59", operator: "<="}
                                ],
                                view: {program: ["id"]}
                            });
                            const programs = locationEvents.items.map(({program}) => program.id).filter((value, index, array) => array.indexOf(value) === index);
                            let programCalendarItems = {items: [], fullcount: 0};
                            if (programs.length > 0) {
                                programCalendarItems = await sendRequest({
                                    option: "componentlist",
                                    component: "ProgramCalendarItem",
                                    parameters: {
                                        from: fromto.from + " 00:00:00",
                                        to: fromto.to + " 23:59:59",
                                        program_id: programs
                                    },
                                    itemsperpage: 0,
                                });
                            }
                            programCalendarItems.items = programCalendarItems.items.map((item) => {
                                item.component_type = "ProgramCalendarItem";
                                return item;
                            });
                            data.rows.push(...programCalendarItems.items);
                            data.fullcount = Number(data.fullcount) + programCalendarItems.items.length;


                        }
                        return data;
                    }}
                />
                <div className="form-group event-calendar indicator">
                    <label className="control-label">Jelmagyarázat:</label>
                    {colors.map((color, idx) => {
                        return <Fragment key={idx}><label className={"label label-" + color.color}>{color.label}</label> </Fragment>;
                    })}
                </div>
            </Fragment>
        );
    }
}

export default EventCalendar;
